import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => (
  <div className="home-container">
    <div className="home-text">
      <h1>
        <span style={{ color: "#09FDD9" }}>Hello,</span>
      </h1>
      <h1>
        I'm <span style={{ color: "#FE0A54" }}>Gurpreet,</span>
      </h1>
      <h1>
        Software <span style={{ color: "#09FDD9" }}>Dev</span> Engineer.
      </h1>
    </div>
    <div className="head-btns">
      <Link to="/about" className="btn btn-white">
        <p className="btn-text">Know more about me</p>
      </Link>
      <Link to="/contact" className="btn btn-transparent">
        <p className="btn-text">Connect with me</p>
      </Link> 
    </div>
  </div>
);

export default Home;